export const prodottoRichiestoShape = {
  id: "",
  nome: "",
  quantita: 1,
  equivalenteConsentito: true,
  formatoDiversoConsentito: false,
  nota: "",
};

export const createProdottoRichiestoModel = (overrides = {}) => ({
  ...prodottoRichiestoShape,
  ...overrides,
});

